import * as React from 'react';
import { useState } from 'react';
import c from 'classnames';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';

import PrimaryItem from './Primary';
import SecondaryItem from './Secondary';
import TertiaryItem from './Tertiary';

import './style.scss';
import Button from '../Button';

interface LinkListSubComponents {
  PrimaryItem: typeof PrimaryItem;
  SecondaryItem: typeof SecondaryItem;
  TertiaryItem: typeof TertiaryItem;
}

interface LinkListProps {
  children: React.ReactNode;
  maxLength?: number;
  className?: string;
}

const LinkList: React.FC<LinkListProps> & LinkListSubComponents = ({
  children,
  maxLength,
  className,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useTranslation();
  const childArray = React.Children.toArray(children);

  const isLongList = maxLength ? childArray.length > maxLength : false;
  const childrenFirstGroup = childArray.slice(0, maxLength);
  let childrenSecondGroup = null;
  if (isLongList) {
    childrenSecondGroup = childArray.slice(maxLength, childArray.length);
  }
  const classes = c('LinkList', className, { expanded: isExpanded, longList: isLongList });

  return (
    <div className={classes}>
      <ul className="firstGroup">
        {childrenFirstGroup}
      </ul>
      { isLongList && (
        <div>
          <ul className="secondGroup">
            {childrenSecondGroup}
          </ul>
          <Button
            type="secondary"
            onClick={(e) => {
              setIsExpanded(!isExpanded);
              (e.currentTarget as HTMLElement).blur();
            }}
          >
            { isExpanded ? t('buttons.show_less') : t('buttons.show_more')}
            <Icon name="expand_more" />
          </Button>
        </div>
      )}
    </div>
  );
};

LinkList.PrimaryItem = PrimaryItem;
LinkList.SecondaryItem = SecondaryItem;
LinkList.TertiaryItem = TertiaryItem;

export default LinkList;
